// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"47404277","382":"168f36d0","438":"932614c7","545":"faf1c519","684":"f50c320e","706":"9f21abd8","873":"0d13929a"}[chunkId] + ".chunk.js";
};